module.exports = __webpack_public_path__ + "img/Speaker=Jean-Michel Lemieux.882d79d2.png";